<template>
  <CRow>
    <CCol col="12" xl="12">
      <div class="adverts-details" v-if="resourcesAdvertDetails.length" id="adverts-listA">
        <div class="adverts-details" v-for="myadvertsdetails in resourcesAdvertDetails" v-bind:key="myadvertsdetails._id">
          <CCard class="advert-card">
            <CCardHeader>
              <!-- <a href="/adverts-list"><b>Back</b></a> -->
              <div class="row">
                <CCol class="col-md-6 float-left align-self-center" >
                  <h4>My Adverts Details</h4>
                </CCol>
                <CCol class="col-md-6 float-right">
                  <CButton color="primary" @click="redirectUrls('/adverts-list')" class="px-4 float-right" type="">Back</CButton>
                </CCol>
              </div>
            </CCardHeader>

            <CCardBody>
              <CRow>
                <CCol col="12" xl="8">
                  <h4 class="username userLink" @click="redirectUserDetails('/users-details/'+myadvertsdetails.userid._id)">{{ myadvertsdetails.userid.firstname }} {{ myadvertsdetails.userid.lastname }}</h4>
                  <strong>Activities:</strong>
                  <ol v-if="myadvertsdetails.activities" id="activities-lists" class="list-unstyled activity-list">
                    <li v-for="activities in myadvertsdetails.activities" v-bind:key="activities._id">
                      {{ activities }}<br/>
                    </li>
                  </ol>
                  <CRow>
                    <CCol col="12" xl="6">
                      <ul class="list-unstyled">
                        <li><strong>Age range:</strong></li>
                        <li>{{ myadvertsdetails.agerange.minage }} to {{ myadvertsdetails.agerange.maxage }}</li>
                      </ul>
                      <ul class="list-unstyled">
                        <li><strong>Time frame (Hours):</strong></li>
                        <li>{{ myadvertsdetails.timeframe.mintime }} to {{ myadvertsdetails.timeframe.maxtime }}</li>
                      </ul>
                    </CCol>
                    <CCol col="12" xl="6">
                      <ul class="list-unstyled">
                        <li><strong>Gender:</strong></li>
                        <li v-if="myadvertsdetails.gender == 'M'">Male</li>
                        <li v-if="myadvertsdetails.gender == 'F'">Female</li>
                        <li v-if="myadvertsdetails.gender == 'Both'">Both</li>
                      </ul>
                      <ul class="list-unstyled">
                        <li><strong>Location:</strong></li>
                        <li>{{myadvertsdetails.location}}</li>
                      </ul>
                    </CCol>
                  </CRow>
                </CCol>

                <CCol col="12" xl="4" class="align-self-center">
                  <img class="w-100 img-thumbnail" :src="myadvertsdetails.image_url" @error="$event.target.src = APP_URL+'no_image.png'" />
                </CCol>
              </CRow>
            <!-- <loading :active.sync="isLoading"
              :can-cancel="false"
              :on-cancel="onCancel"
              :is-full-page="fullPage"></loading>

                <b>Advert details</b>: <ul v-if="resources.length" id="adverts-list">
                <li v-for="advertsdetails in resources" v-bind:key="advertsdetails._id">

                  <b>User name: {{ advertsdetails.userid.firstname }} {{ advertsdetails.userid.lastname }}</b><br/>
                  Activities: <ul v-if="advertsdetails.activities" id="activities-lists">{{ activities }}
                    <li v-for="activities in advertsdetails.activities" v-bind:key="activities._id">
                      {{ activities }}<br/>
                    </li>
                  </ul><br/>
                  Age range: {{ advertsdetails.agerange.minage }} to {{ advertsdetails.agerange.maxage }}<br/>
                  Time frame: {{ advertsdetails.timeframe.mintime }} to {{ advertsdetails.timeframe.maxtime }}<br/>
                  Pic: <img style="width: 200px; height: auto;" :src="API_URL+'images/' + advertsdetails.pic" @error="$event.target.src = APP_URL+'no_image.png'" /><br/>
                  Current location: {{ advertsdetails.currentlocation.lat }} - {{ advertsdetails.currentlocation.long }}<br/>
                  Gender: <span v-if="advertsdetails.gender == 'M'">Male</span>
                          <span v-if="advertsdetails.gender == 'F'">Female</span>
                          <span v-if="advertsdetails.gender == 'Both'">Both</span><br/>
                  Location: {{advertsdetails.location}}<br/>

                </li>
              </ul>
              <p v-else>No details</p> -->

            </CCardBody>
          </CCard>
        </div>
      </div>
      <div class="adverts-details" v-if="resources.length" id="adverts-list">
        <div class="adverts-details" v-for="advertsdetails in resources" v-bind:key="advertsdetails._id">
          <CCard v-if="advertsdetails.isa.length">
            <CCardHeader>
              <CRow>
                <CCol col="12" xl="12">
                  <h4>Interest Shown:</h4>
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody id="adverts-listS">
              <CRow>
                <CCol col="12" xl="4" v-for="advertsdetailsShown in advertsdetails.isa" v-bind:key="advertsdetailsShown._id">
                  <div class="gray-box">
                    <div class="image-block">
                      <img class="w-100" :src="API_URL+'images/' + advertsdetailsShown.pic" @error="$event.target.src = APP_URL+'no_image.png'" /><br/>
                    </div>
                    <div class="content-block">
                      <ul class="list-unstyled mb-0">
                        <li>
                          <h5 class="mb-0">User name:</h5>
                          <p class="userLink" @click="redirectUserDetails('/users-details/'+advertsdetailsShown.userid[0]._id)">{{ advertsdetailsShown.userid[0].firstname }} {{ advertsdetailsShown.userid[0].lastname }}</p>
                        <li/>
                        <li>
                          <h5 class="mb-0">Activities</h5>
                          <ul class="list-unstyled activity-list mb-3" v-if="advertsdetailsShown.activities" id="activities-lists">
                            <li v-for="activities in advertsdetailsShown.activities" v-bind:key="activities._id">
                                {{ activities }}<br/>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <h5 class="mb-0">Age range:</h5>
                          <p>{{ advertsdetailsShown.agerange.minage }} to {{ advertsdetailsShown.agerange.maxage }}</p>
                        </li>
                        <li>
                          <h5 class="mb-0">Gender:</h5>
                          <p><span v-if="advertsdetailsShown.gender == 'M'">Male</span>
                            <span v-if="advertsdetailsShown.gender == 'F'">Female</span>
                            <span v-if="advertsdetailsShown.gender == 'Both'">Both</span></p>
                        </li>
                        <li>
                          <h5 class="mb-0">Time frame (Hours):</h5>
                          <p>{{ advertsdetailsShown.timeframe.mintime }} to {{ advertsdetailsShown.timeframe.maxtime }}</p>
                        </li>
                        <li>
                          <h5 class="mb-0">Location:</h5>
                          <p >{{advertsdetailsShown.location}}</p>
                        </li>
                        <li>
                          <h5 class="mb-0">Current distance:</h5>
                          <p>{{ advertsdetailsShown.distance }} km</p>
                        </li>
                        <li>
                          <h5 class="mb-0">Status:</h5>
                          <p v-if="advertsdetailsShown.interestShownFlag == 1">Pending</p>
                          <p v-if="advertsdetailsShown.interestShownFlag == 2">Accepted</p>
                          <p v-if="advertsdetailsShown.interestShownFlag == 3">Rejected</p>
                          <p v-if="advertsdetailsShown.interestShownFlag == 8">Hold</p>
                          <h5 class="mb-0">Date:</h5>
                          <p v-if="advertsdetailsShown.interestPendingDate && advertsdetailsShown.interestShownFlag == 1">{{ advertsdetailsShown.interestPendingDate | momentDate }}</p>
                          <p v-if="advertsdetailsShown.interestAcceptedDate && advertsdetailsShown.interestShownFlag == 2">{{ advertsdetailsShown.interestAcceptedDate | momentDate }}</p>
                          <p v-if="advertsdetailsShown.interestRejectedDate && advertsdetailsShown.interestShownFlag == 3">{{ advertsdetailsShown.interestRejectedDate | momentDate }}</p>
                          <p v-if="advertsdetailsShown.interestHoldDate && advertsdetailsShown.interestShownFlag == 8">{{ advertsdetailsShown.interestHoldDate | momentDate }}</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>


          <CCard v-if="advertsdetails.ica.length">
            <CCardHeader>
              <CRow>
                <CCol col="12" xl="12">
                    <h4>Interest Created:</h4>
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody id="adverts-listC">
              <CRow>
                <CCol col="12" xl="4" v-for="advertsdetailsCreated in advertsdetails.ica" v-bind:key="advertsdetailsCreated._id">
                  <div class="gray-box">
                    <div class="image-block">
                      <img class="w-100" :src="advertsdetailsCreated.pic" @error="$event.target.src = APP_URL+'no_image.png'" /><br/>
                    </div>
                    <div class="content-block">
                      <ul class="list-unstyled mb-0">
                        <li>
                          <h5 class="mb-0">User name:</h5>
                          <p class="userLink" @click="redirectUrls('/users-details/'+advertsdetailsCreated.userid[0]._id)">{{ advertsdetailsCreated.userid[0].firstname }} {{ advertsdetailsCreated.userid[0].lastname }}</p>
                        <li/>
                        <li>
                          <h5 class="mb-0">Activities</h5>
                          <ul class="list-unstyled activity-list mb-3" v-if="advertsdetailsCreated.activities" id="activities-lists">
                            <li v-for="activities in advertsdetailsCreated.activities" v-bind:key="activities._id">
                                {{ activities }}<br/>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <h5 class="mb-0">Age range:</h5>
                          <p>{{ advertsdetailsCreated.agerange.minage }} to {{ advertsdetailsCreated.agerange.maxage }}</p>
                        </li>
                        <li>
                          <h5 class="mb-0">Gender:</h5>
                          <p><span v-if="advertsdetailsCreated.gender == 'M'">Male</span>
                            <span v-if="advertsdetailsCreated.gender == 'F'">Female</span>
                            <span v-if="advertsdetailsCreated.gender == 'Both'">Both</span></p>
                        </li>
                        <li>
                          <h5 class="mb-0">Time frame (Hours):</h5>
                          <p>{{ advertsdetailsCreated.timeframe.mintime }} to {{ advertsdetailsCreated.timeframe.maxtime }}</p>
                        </li>
                        <li>
                          <h5 class="mb-0">Location:</h5>
                          <p >{{advertsdetailsCreated.location}}</p>
                        </li>
                        <li>
                          <h5 class="mb-0">Current distance:</h5>
                          <p>{{ advertsdetailsCreated.distance }} km</p>
                        </li>
                        <li>
                          <h5 class="mb-0">Status:</h5>
                          <p v-if="advertsdetailsCreated.interestCreatedFlag == 1">Pending</p>
                          <p v-if="advertsdetailsCreated.interestCreatedFlag == 2">Accepted</p>
                          <p v-if="advertsdetailsCreated.interestCreatedFlag == 3">Rejected</p>
                          <p v-if="advertsdetailsCreated.interestCreatedFlag == 8">Hold</p>
                          <h5 class="mb-0">Date:</h5>
                          <p v-if="advertsdetailsCreated.interestPendingDate && advertsdetailsCreated.interestCreatedFlag == 1">{{ advertsdetailsCreated.interestPendingDate | momentDate }}</p>
                          <p v-if="advertsdetailsCreated.interestAcceptedDate && advertsdetailsCreated.interestCreatedFlag == 2">{{ advertsdetailsCreated.interestAcceptedDate | momentDate }}</p>
                          <p v-if="advertsdetailsCreated.interestRejectedDate && advertsdetailsCreated.interestCreatedFlag == 3">{{ advertsdetailsCreated.interestRejectedDate | momentDate }}</p>
                          <p v-if="advertsdetailsCreated.interestHoldDate && advertsdetailsCreated.interestCreatedFlag == 8">{{ advertsdetailsCreated.interestHoldDate | momentDate }}</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </div>
      </div>
      <!-- <div v-if="resources.length == 0" id="">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="12" xl="12">
                <h4>No matching adverts</h4>
              </CCol>
            </CRow>
          </CCardHeader>
        </CCard>
      </div> -->
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    name: 'advertDetail',
    data() {
        return {
            isLoading: false,
            fullPage: true,
            resources: [],
            resourcesAdvertDetails: [],
            activeOptions: [{id: 0, text: 'Deactive'}, {id: 1, text: 'Active'}],
            API_URL: API_URL,
            APP_URL: APP_URL,
            token: localStorage.getItem('token'),
            tokenChange: JSON.parse(localStorage.getItem('token')),
        }
    },
    components: {
        Loading
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    components: {
        Loading
    },
    created() {
        document.title = "Advert Detail";
        this.loadData();
        this.myAdvertDetails();
    },
    methods: {
      loadData() {
        let id = this.$route.params.id
        this.isLoading = true;
        axios.get(`${API_ADMIN_URL}/adminAdvertDetails/`+id, {headers: {'x-access-token': this.tokenChange}}).then(response => {
          if (response.data.status == 200) {
            this.resources = response.data.data;
            this.isLoading = false;
          } else {
              this.isLoading = false;
              localStorage.clear();
              this.$router.push('/login');
          }
          this.isLoading = false;
        });
      },
      myAdvertDetails() {
        let id = this.$route.params.id
        this.isLoading = true;
        axios.get(`${API_ADMIN_URL}/myAdvert/`+id, {headers: {'x-access-token': this.tokenChange}}).then(response => {
          if (response.data.status == 200) {
            this.resourcesAdvertDetails = response.data.data;
            this.isLoading = false;
          }
          else {
              this.isLoading = false;
              localStorage.clear();
              this.$router.push('/login');
          }
        });
      },
      moment: function (date) {
        return moment(date);
      },
      redirectUserDetails: function(link) {
        //this.$router.push(link);
        window.open(link, '_blank');
      },
      redirectUrls: function(link) {
        this.$router.push(link);
        //window.open(link, '_blank');
      }
    }
}
</script>
